import { ContractType } from '@features/termination/enums';

export interface TerminationInformation {
  contractType: string;
  terminationType: string;
  contract: string;
  contractName: string;
  contractNumber: string;
  terminationDate: string;
  terminationReason: string;
  otherReason: string;
}

export const initialTerminationInformation = {
  contractType: ContractType.BANKING_PRODUCT,
  terminationType: '',
  contract: '',
  contractName: '',
  contractNumber: '',
  terminationDate: new Date().toLocaleDateString('fr-FR'),
  terminationReason: '',
  otherReason: '',
};
